/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getFeed.defs.js'
export * as $defs from './getFeed.defs.js'
